export const styles = (theme) => ({
  pageHeaderContainer: {
    padding: 15,
    borderBottom: "1px solid #cac5c5d9",
  },
});
